import { Component, OnInit } from '@angular/core';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;

  constructor(
    public auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
  }
  //とち活関連
  business_operator() {
    this.router.navigate(['/business-operator/']);
  }

  //ユーザー管理
  user_management() {
    this.router.navigate(['/user-management/']);
  }
  //権限管理
  related() {
    this.router.navigate(['/related/']);
  }
  //コード管理
  item_setting() {
    this.router.navigate(['/item-setting/']);
  }
  //TOP検索条件
  search_top() {
    this.router.navigate(['/search-top/']);
  }
  //面談場所管理
  place_setting() {
    this.router.navigate(['/place/']);
  }


}
